import {
    dictionary,
    locale,
    _
} from 'svelte-i18n';
function setupI18n({ withLocale: _locale} = { withLocale: 'en-US' }) {
    dictionary.set({
        'en-US': {
            'header': {
                'logo': '/spy20-lk/img/datajam-logo.svg',
                'logoSmall': '/spy20-lk/img/datajam-logo-small.svg',
            },
            'footer': {
                'logo': '/spy20-lk/img/datajam-footer-logo.svg',
                'logoSmall': '/spy20-lk/img/datajam-footer-logo.svg',
                'contactNumber': ' ',
                'contactNumberString': ' ',
                'serviceName': 'DataJam',
                'contactAddress': 'UAB "Ėuroneká"',
                'privacyRules': 'Privacy policy',
                'userTerms': 'User Agreement',
                'refundPolicy': 'Refund policy',
                'disclaimer': ' ',
                'paymentIcons': '<img src="/img/icons/master_card.svg" alt="master_card" /><img src="/img/icons/visa.svg" alt="visa" />',
            },
            'signUpForm': {
                'title': 'Sign Up',
                'description': 'Enter login and password, which you are going to use',
                'emailInputPlaceholder': 'Enter email',
                'passwordInputPlaceholder': 'Enter password',
                'registerBtnLabel': 'Sign Up',
                'orRegisterViaSocials': 'or sign up via social networks',
                'alreadyRegisteredLabel': 'Already sign up?',
                'signInBtnLabel': 'Sign-in',
            },
            'signInForm': {
                'title': 'Sign-in',
                'description': 'Enter login and password, which you have entered during registration',
                'emailInputPlaceholder': 'Enter email',
                'passwordInputPlaceholder': 'Enter password',
                'signInBtnLabel': 'Sign-in',
                'orSignInViaSocials': 'or authorize via social networks',
                'lostAccessBtnLabel': 'Unable to sign-in',
                'registerBtnLabel': 'Sign Up',
                'firstTimeUserBtnLabel': 'Don\'t have an account yet?',
            },
            'resetPasswordRequestForm': {
                'title': 'Password recovery',
                'description': 'Reset password and send new one to email, used during registration',
                'requestSentDescription': 'Email with instructions have been sent to your email',
                'backBtnLabel': 'back',
                'emailInputPlaceholder': 'Enter email, used during registration',
                'continueBtnLabel': 'continue',
            },
            'changePasswordForm': {
                'title': 'New password',
                'description': 'Enter new password for authorization',
                'newPasswordInputPlaceholder': 'Enter new password',
                'continueBtnLabel': 'continue',
                'backBtnLabel': 'back',
            }
        },
        'ru-RU': {
            'header': {
                'logo': '/spy20-lk/img/instashpion-logo.svg',
                'logoSmall': '/spy20-lk/img/instashpion-logo-small.svg',
            },
            'footer': {
                'logo': '/spy20-lk/img/instashpion-logo.svg',
                'logoSmall': '/spy20-lk/img/instashpion-logo-small.svg',
                'contactNumber': '+74994600332',
                'contactNumberString': '+7 (499) 460-03-32',
                'serviceName': 'Инсташпион',
                'contactAddress': 'Пресненская наб., 12, БЦ, Москва',
                'privacyRules': 'Политика конфиденциальности',
                'userTerms': 'Пользовательское соглашение',
                'refundPolicy': 'Политика возвратов',
                'disclaimer': '* Принадлежит организации Meta, признанная судом в РФ экстремистской. Данные меры судебной защиты не ограничивают действий по использованию программных продуктов компании Meta физических и юридических лиц, не принимающих участия в запрещенной законом деятельности.',
                'paymentIcons': '<img src="/img/icons/master_card.svg" alt="master_card"><img src="/img/icons/visa.svg" alt="visa"><img src="/img/icons/mir.svg" alt="mir">',
            },
            'signUpForm': {
                'title': 'Регистрация',
                'description': 'Или введите почту и пароль, которые вы хотите использовать для регистрации на Инсташпионе',
                'emailInputPlaceholder': 'Введите e-mail',
                'passwordInputPlaceholder': 'Введите пароль',
                'registerBtnLabel': 'зарегистрироваться',
                'orRegisterViaSocials': 'Зарегистрируйтесь с помощью аккаунта',
                'alreadyRegisteredLabel': 'Уже есть аккаунт?',
                'signInBtnLabel': 'авторизуйтесь',
            },
            'signInForm': {
                'title': 'Вход',
                'description': 'Или введите данные, которые вы использовали при регистрации:',
                'emailInputPlaceholder': 'Введите e-mail',
                'passwordInputPlaceholder': 'Введите пароль',
                'signInBtnLabel': 'войти',
                'orSignInViaSocials': 'С помощью связанного аккаунта',
                'lostAccessBtnLabel': 'Не могу войти',
                'registerBtnLabel': 'зарегистрируйтесь',
                'firstTimeUserBtnLabel': 'Впервые у нас?',
            },
            'resetPasswordRequestForm': {
                'title': 'Восстановление пароля',
                'description': 'Сбросить пароль и выслать новый на указанный адрес',
                'requestSentDescription': 'Письмо с инструкцией отправлено на указанный адрес',
                'backBtnLabel': 'назад',
                'emailInputPlaceholder': 'Введите e-mail регистрации',
                'continueBtnLabel': 'продолжить',
            },
            'changePasswordForm': {
                'title': 'Новый пароль',
                'description': 'Укажите новый пароль, который вы будете использовать для авторизации',
                'newPasswordInputPlaceholder': 'Укажите новый пароль',
                'continueBtnLabel': 'продолжить',
                'backBtnLabel': 'назад',
            }
        },
    });
    locale.set(_locale);
}
export {
    _,
    setupI18n
};